export const FETCH_ALL_SETTINGS = 'settings/fetchAllSettings';
export const UPDATE_SETTING = 'settings/updateSetting';
export const FETCH_WORK_ORDERS = 'workOrders/fetchWorkOrders';
export const UPDATE_WORK_ORDER_STATUS = 'workOrders/updateWorkOrderStatus';
export const FETCH_ONE_WORK_ORDER = 'workOrders/fetchOneWorkOrder';
export const FETCH_TOTAL_WORK_ORDERS_COUNT = 'workOrders/fetchTotalWorkOrdersCount';
export const FETCH_MORTGAGE_RATES = 'mortgageRates/fetchAll'
